import './LoadingScreen.css';

export function LoadingScreen() {
  return (
    <div className="loading-screen-fade">
      <div className="loading-spinner loading-spinner-brand" />
    </div>
  );
}
